<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-26 15:09:19
 * @LastEditTime: 2019-08-18 19:26:57
 * @LastEditors: Please set LastEditors
 -->
<!--入库明细-->
<template>
    <el-dialog
            title="信息"
            :visible="true"
            width="70%"
            :before-close="handleClose">
        <el-button type="primary" @click="exportData()">导出</el-button>
        <el-table
                ref="multipleTable"
                v-loading="loading"
                :data="tableData"
                border
                height="350"
                style="width: 100%;margin-top: 20px">
            <el-table-column
                    label="序号"
                    width="80"
                    prop="id"
                    fixed
            >
            </el-table-column>
            <el-table-column
                    prop="stock_in_sn"
                    label="入库单号"
                    width="120"
                    fixed>
            </el-table-column>
            <el-table-column
                    prop="production_batch"
                    label="生产批次号"
                    width="120"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="product_specs"
                    label="规格"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="production_date"
                    label="生产日期"
                    width="120"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="expiring_date"
                    label="有效期至"
                    width="120"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="warehouse_name"
                    label="入库仓库"
                    width="120"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="real_stock_in_num"
                    label="入库数量"
                    width="120"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="logistics_code"
                    label="物流码"
                    width="120"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="code_name"
                    label="标签类型"
                    width="120"
                    show-overflow-tooltip>
            </el-table-column>
        </el-table>
        <!--分页-->
        <el-pagination
                style="margin: 20px 0"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNo"
                :page-sizes="[20, 50, 100, 200]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalSize">
        </el-pagination>
    </el-dialog>
    
</template>

<script>
    export default {
        name: "instock-detail-dialog",
        data() {
            return {
                tableData:[],
                //分页
                pageNo: 1,//页码
                pageSize: 20,//每页现实的条数
                totalSize: 0,//总条数
                loading:false,
            }
        },
        props:{
            stock_in_sn:{
                type:String,
                default:''
            }
        },
        methods: {
            getData(){
                let url = '/statistics/inwarehouses/' + this.stock_in_sn;
                this.loading=true;
                this.$get('logistics',url, {
                    lang:'',
                    inwarehouse:this.stock_in_sn,
                    per_page:this.pageSize,
                    page:this.pageNo
                }).then(res => {
                    this.loading=false;
                    this.tableData = res.data;
                    this.totalSize = res.meta.total;
                }).catch(function (error) {
                    this.loading=false;
                    console.log(error);
                });

            },
            //导出
            exportData(){
                let url = '',access_tokens = localStorage.getItem('access_tokens');
           

                window.open(this.$Base_Export
                    +'/statistics/inwarehouses/' + this.stock_in_sn +'/export?is_export=1&inwarehouse=' + this.stock_in_sn +'&lang=' + ''+'&signature='+ this.$md5(access_tokens)

                )
            },
            /*分页*/
            handleSizeChange(val) {
                this.pageSize = val;
                this.pageNo = 1;
                this.getData();

            },
            handleCurrentChange(val) {
                this.pageNo = val;
                this.getData();

            },
            handleClose(){
                this.$emit('handleClose');
            }
        },
        created() {
            this.getData();
        },
    }
</script>

<style lang="scss" scoped>

</style>